import logoWhite from './logo-white.png';
import './App.css';
import {Button} from "@mui/material";
import {Link, Outlet} from "react-router-dom";
import MainNav from "./Layout/MainNav";

function App() {

    const footer = [
        {name: 'Dla Organizatorów', link: '/dla-organizatorow'},
        {name: 'Kontakt', link: '/kontakt'},
        {name: 'Centrum Pomocy', link: '/faq'},
        {name: 'Polityka Prywatności', link: '/polityka-prywatnosci'},
        {name: 'Regulamin', link: '/regulamin'}
    ];

  return (<>
          <div className="App">
              <MainNav />
              <Outlet/>
          </div>
          <footer className={'App-footer'}>
              <div className={'footer-info'}>
                  <div style={{flexGrow: 1, textAlign: 'center'}}><img src={logoWhite} alt="logo"/></div>
                  <div style={{flexGrow: 1, textAlign: 'center'}}>
                      <ul style={{listStyleType: 'none', margin: '0 auto', padding: '0', width: '200px'}}>
                          {footer.map((item, index) => (
                              <li style={{width: '100%'}}>
                                  <Link to={item.link} key={index} style={{width: '100%'}}>
                                      <Button fullWidth sx={{textTransform: 'none', color: 'white'}}>{item.name}</Button>
                                  </Link>
                              </li>
                          ))}
                      </ul>
                  </div>
              </div>
              <div style={{padding: '5px 30px'}}>&copy; 2026 Grupa <a style={{color: '#F69F1C', textDecoration: 'none'}} href={'https://kidplace.pl'}>Kidplace</a>. Oprogramowanie dla oświaty.</div>
          </footer>
      </>
  );
}

export default App;
